import React, { lazy, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Container, Tab, Tabs, Row, Col, Alert } from "react-bootstrap";
import { Button, FormCanvas, Loader, Loading, Message, StatusBar } from "../UI";
import ErCanvas from "../UI/ErCanvas";
import * as commonData from "../../Common";
import { Formik, Form, Field } from "formik";
import { string, object, number, array, date } from "yup";
import AsyncSelect from "react-select/async";
import ReactSelect, { components } from "react-select";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import CountStatusBarComponent from "../Board/CountStatusBarComponent";
import { columnResize } from "../../Actions/columns-resize";
import AgGridComponent from "../AgGridComponent";
import { bulkUpdate } from "../../Actions/bulkUpdate";
import moment from "moment";
import Error from "../Error";
import { UploadImage } from "../../Actions/imageUpload";
import { preview } from "../../helpers/preview";
import Modal from "../UI/modal/Modal";
import "../../assets/agthemechild.css";
import TextAreaCompo from "./TextAreaCompo";
import removeChildBoardImage from "../../Actions/removeChildBoardImage";
import ImagePreview from "../UI/ImagePreview";
import RelateEr from "./RelateEr";
import AutoCompleteRelateER from "./AutoCompleteRelateER";
import ReactDatePicker from "react-datepicker";
import DraftjsInline from "./DraftjsInline";
import { getBoardHistory } from "../../Actions/update-single-row";
import CustomOption from "../CustomOption";
import { AiOutlineFullscreen } from "react-icons/ai";
import { IoMdClose } from "react-icons/io";
import apiHandler from "../../utils/apiHandler";
import { checkEffortHandler } from "../../utils/utility";
import DropDownButon from "../UI/DropDownButton";
import TimeSvg from "../UI/svg/TimeSvg";


let newarrayAll = [];
const ChildBoard = ({
  child_board,
  set_type,
  parent_attribute_set_key,
  attribute_set_type,
  getHistoryData,
  changeTheActiveTab,
  childBoardDataChanged,
  filterData,
  clearSegmentFun,
  main_attribute_set_key,
  ...rest
}) => {
  const para = useParams();
  const bulkupdate = useSelector((state) => state.attributes);
  const boardAttr = useSelector((state) => state.boardAttribute);
  const dispatch = useDispatch();
  const gridrefval = useRef(null);
  let gfinterval = useRef(null);
  let boardvalue = useRef(null);
  let attrKey = useRef(null);
  let filterIcon = useRef([]);
  const freeze = useRef(null);
  let focusRef = useRef([]);
  const timeframe = useRef(null);
  const [showCanvas, setShowCanvas] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const [info, setInfo] = useState({ ...commonData.getCommonData() });
  const [loading, setLoading] = useState(true);
  const [gridKey, setGridKey] = useState(0);
  const [search, setSearch] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [state, setState] = useState({
    rowData: [],
    showModal: false,
    attachShow: false,
    totalRecord: {},
    editorState: "",
    removeEditImageUuid: "",
    rows: [],
    imageFailedError: [],
    bulkUpdateDone: false,
    startSearch: false,
    errorRelation: {},
    deleteId: "",
    isFullScreenView: false,
    relationAdded: false,
    mainImageUpload: false,
    relatedErApiData: [],
    deleteChildRecord: false,
    deselectAll: false,
    relateColumnData: [],
    relateRowData: [],
    attachImages: {},
    releatedApiData: [],
    renderchilder: false,
    boardOptions: [],
    related_tattle_id: "",
    relation_type: 1,
    relationType: [],
    isReset: false,
    isLoading: false,
    // categoryBboardID: "",
    attributes: [],
    showModalEditRemove: false,
    clearautocomplete: false,
    removeEditErImage: false,
    attachments: [],
    isImageUpload: false,
    isAdding: false,
    attachment_uuid: "",
    rowDataId: "",
    removeerinfoUuid: "",
    users: [],
    allUsers: {},
    showEditForm: false,
    editForm: [],
    child_board: [],
    editAttribute: [],
    attachmentUpload: {},
    selectColumnsCheck: [],
    saveImageFile: {},
    childBoardId: "",
    resetFilter: false,
    showattrdrop: false,
    columnsHide: [],
    showErDetails: false,
    name: "",
    globalSearch: "",
    key: child_board?.[0]?.attribute_set_key,
    keyname: child_board?.[0]?.attribute_set_name,
    statusBar: {
      statusPanels: [
        {
          statusPanel: CountStatusBarComponent,
          key: "CountStatusBarComponent",
        },
      ],
    },
    conditions: { sort: [], filter: [] },
    perPage: {
      pagination_default_value: 20,
      editpagesize: false,
      totalCount: 0,
    },
    filterMod: {},
    gridApi: "",
    columnApi: "",
    columns: [],
    defaultVal: {},
    selectedrowsdata: [],
    newapi: "",
    rowSelection: "multiple",
    createBoard: {
      board: false,
      message: "",
      title: "",
      bg: "primary",
      position: "bottom-end",
    },
    defaultAsyncValue: {},
    boardConfig: {isExternal:false}
  });

const safeParse = (str, fallback = {}) => {
  try {
    return str ? JSON.parse(str) : fallback;
  } catch (e) {
    console.error("Invalid JSON in board_config:", str);
    return fallback;
  }
};

  useEffect(() => {
    childBoardDataChanged();
  }, [state.totalRecord]);

  useEffect(() => {
    getFilterParams(state.newapi, filterData, true);
  }, [filterData])


const firstBoardConfig = useMemo(() => {
  if (state.child_board?.[0]?.board_config) {
    const pars = safeParse(state.child_board[0].board_config)
    setState((state) => ({
      ...state,
      boardConfig:pars
    }));
    return pars;
  }
  return {};
}, [state.child_board]);


  const getCallRelatonFunc = async () => {
    // griddapi?.current?.showLoadingOverlay();
    const response = await fetch(
      `${commonData.commonData().apiUrl}tattle/get-relation`,
      {
        method: "POST",
        body: JSON.stringify({
          app_token: commonData.getCommonData().app_token,
          attribute_set_key: para.attribute_set_key,
          customer_tattle_uuid: Number(para.id),
        }),
      }
    );
    const rdata = await response.json();
    if (rdata.code === 200) {
      // griddapi.current?.hideOverlay();
      setTimeout(() => {
        setState((state) => {
          return {
            ...state,
            filterDataRow: [],
            relateColumnData: rdata.columns,
            relateRowData: rdata.data,
          };
        });
      }, 100);
    } else {
      // griddapi.current.showNoRowsOverlay();
      setState((state) => {
        return {
          ...state,
          relateRowData: rdata.data || [],
          relateColumnData: rdata.columns || [],
        };
      });
    }
    return rdata;
  };
  // show canvas with filter attributes columns
  const showCanvasHandler = async (name, key) => {
    setState((prevState) => {
      return {
        ...prevState,
        name: name,
        key: key,
        isAdding: false,
        editForm: {},
        saveImageFile: {},
      };
    });
    setShowCanvas(true);
  };

  useEffect(() => {
    const handleKeyEvent = (event) => {
      if (event.key === "Escape") {
        setGridKey((key) => key + 1);
        setState((state) => {
          return {
            ...state,
            isFullScreenView: false,
          };
        });
      }
    };
    document.addEventListener("keydown", handleKeyEvent);
    return () => {
      document.removeEventListener("keydown", handleKeyEvent);
    };
  }, [state.isFullScreenView]);
  // set the child board

  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        columns: child_board?.[0]?.data.list || [],
        key: child_board?.[0]?.attribute_set_key,
        keyname: child_board?.[0]?.attribute_set_name,
        child_board: child_board,
      };
    });
  }, [child_board]);

  useEffect(() => {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    setSearchTimeout(
      setTimeout(() => {
        setSearch(null);
      }, 1000)
    );

    return () => clearTimeout(searchTimeout);
  }, [search]);
  const getPeoplesCall = async (evt, apiUrl) => {
    if (evt && state.users.length > 0) {
      return state.users.filter((item) =>
        item.label.toLowerCase().includes(evt.toLowerCase())
      );
    }
    const resp = await fetch(apiUrl);
    const rdata = await resp.json();
    const newdata = Object.entries(rdata).map(([key, val]) => {
      return {
        label: val.name,
        value: val.user_uuid,
        profile_image: val.profile_image,
      };
    });
    setState((state) => {
      return {
        ...state,
        users: newdata,
      };
    });
    return newdata;
  };
  const handleCloseEr = useCallback(() => {
    setShowCanvas(false);
    setState((state) => {
      return {
        ...state,
        showErDetails: false,
        showEditForm: false,
      };
    });
  }, [showCanvas]);
  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        allUsers: rest.users,
      };
    });
  }, [rest.users]);
  // useEffect(() => {
  //   for (let board of child_board) {
  //     if (board.attribute_set_key === "relate") {
  //       callRelateErApi();
  //     }
  //   }
  // }, [child_board]);

  const callRelateErApi = async () => {
    const response = await fetch(`${info.apiUrl}tattle/get-relation`, {
      method: "POST",
      body: JSON.stringify({
        app_token: info.app_token,
        attribute_set_key: para.attribute_set_key,
        customer_tattle_uuid: Number(para.id),
      }),
    });

    const rdata = await response.json();

    if (rdata.code == 200) {
      setState((state) => {
        return {
          ...state,
          relateRowData: rdata.data,
          relateColumnData: rdata.columns,
        };
      });
    }
  };

  useEffect(() => {
    if (!child_board?.length) return;
  
    const run = async () => {
      for (let board of child_board) {
  
        // Case 1: relate tab
        if (board.attribute_set_key === "relate") {
          try {
            await callRelateErApi();
          } catch (err) {
            console.error("Error in callRelateErApi:", err);
          }
        }
  
        // Case 2: external board
        if (state.boardConfig?.isExternal) {
          try {
            const [formRes, relateRes] = await Promise.all([
              fetchBoardForm(state.key),
              // callRelateErApi(),
            ]);
  
            setAttributes(formRes?.data || []);
            // if you need relateRes, handle here too
          } catch (err) {
            console.error("Error fetching external board data:", err);
          }
        }
      }
    };
  
    run();
  }, [state.key, state.boardConfig?.isExternal]);
  

  // on Sort Request

  const onSortRequested = (gridrefval) => {
    if (gridrefval?.column?.sort === "none") {
      gridrefval?.setSort("asc");
    } else if (gridrefval?.column?.sort === "desc") {
      gridrefval.setSort("asc");
    } else {
      gridrefval.setSort("desc");
    }
  };
  const removeUploadImage = (item) => {
    const newstate = {
      ...delete state.saveImageFile[item],
      ...state.saveImageFile,
    };
    setState((state) => {
      return {
        ...state,
        saveImageFile: newstate,
      };
    });
  };
  // on row value changed
  useEffect(() => {
    if (timeframe.current) {
      clearTimeout(timeframe.current);
    }

    timeframe.current = setTimeout(() => {
      if (state.globalSearch) {
        onGridReady(gridrefval.current, state.key, "", state.globalSearch);
      } else {
        if (state.startSearch) {
          onGridReady(gridrefval.current, state.key, "", "null");
        }
      }
    }, 500);

    return () => {
      clearTimeout(timeframe.current);
    };
  }, [state.globalSearch]);

  //searching grid

  const searchGrid = (event) => {
    setState((state) => {
      return {
        ...state,
        startSearch: true,
      };
    });
    const { name, value } = event.target;
    if (value) {
      setTimeout(() => {
        setState((prevVa) => {
          return { ...prevVa, globalSearch: value };
        });
      });
    } else {
      setTimeout(() => {
        setState((prevVa) => {
          return { ...prevVa, globalSearch: "" };
        });
      });
    }
  };

  // filter function

  const getFilterParams = (api, data, clear = false) => {
    setState((prev) => {
      return {
        ...prev,
        newapi: api,
      };
    });

    if (clear) {
      if (gridrefval.current?.api) {
        gridrefval.current.api.setFilterModel(null);
        gridrefval.current.api.onFilterChanged();
      }

      // Reset filterIcon to only the current data keys (empty array if no active filters)
      filterIcon.current = Object.keys(data).filter(key =>
        (Array.isArray(data[key]) && data[key].length > 0) ||
        (typeof data[key] === "string" && data[key] !== "")
      );

      setState((prev) => ({
        ...prev,
        selectColumnsCheck: filterIcon.current,
        filterMod: { ...data }, // Use the provided data (should be empty/cleared filters)
        // isReset: true
      }));
      return; // stop further processing
    }

    // Process filter changes when clear is false
    const bb = Object.keys(data);
    const updatedFilterIcon = [...filterIcon.current];

    bb.forEach((ite) => {
      const hasValidFilterValue =
        (Array.isArray(data[ite]) && data[ite].length > 0) ||
        (typeof data[ite] === "string" && data[ite] !== "");

      if (hasValidFilterValue) {
        // Add to filterIcon if not already present
        if (!updatedFilterIcon.includes(ite)) {
          updatedFilterIcon.push(ite);
        }
      } else {
        // Remove from filterIcon
        const finIndex = updatedFilterIcon.findIndex((item) => item === ite);
        if (finIndex !== -1) {
          updatedFilterIcon.splice(finIndex, 1);
        }
      }
    });

    // Update filterIcon reference
    filterIcon.current = [...new Set(updatedFilterIcon)];

    // Single state update for better performance
    setState((prevState) => {
      const newFilterMod = { ...prevState.filterMod };

      // Update filterMod with current data
      bb.forEach(ite => {
        const hasValidFilterValue =
          (Array.isArray(data[ite]) && data[ite].length > 0) ||
          (typeof data[ite] === "string" && data[ite] !== "");

        if (hasValidFilterValue) {
          newFilterMod[ite] = data[ite];
        } else {
          delete newFilterMod[ite];
        }
      });

      return {
        ...prevState,
        selectColumnsCheck: filterIcon.current,
        filterMod: newFilterMod,
      };
    });
  };

  useEffect(() => {
    if (Object.keys(state.filterMod).length > 0) {
      onGridReady(state.newapi, state.key, state.filterMod);
    }
  }, [state.filterMod, state.newapi]);

  // useEffect(() => {
  //   console.log(state.globalSearch, 654321456545465);
  //   onGridReady(gridrefval, state.key);
  // }, [state.globalSearch]);

  // call the ag grid function onGrid

  const selectAllRowHandler = (evt, params) => {
    const { name, checked } = evt.target;
    if (checked === true) {
      params.api.forEachNode(function (node) {
        node.setSelected(true);
      });
    } else {
      params.api.deselectAll();
    }
  };
  //upoad attachment

  const uploadAttachment = (evt) => {
    const files = evt.target.files;
    let inputs = {
      images: [...files],
      app_token: info.app_token,
      attribute_set_key: attrKey.current || state.key,
      product_key: process.env.REACT_APP_PRODUCT_KEY,
      key: "child_board_er",
    };
    dispatch(UploadImage(inputs));
  };
  const onColumnResized = (params, key) => {
    if (params.source === "uiColumnDragged") {
      const columnspropetise = params.column?.colDef;
      const formvalues = {
        ...columnspropetise,
        width: params.column?.actualWidth || 275,
      };
      const { options, ...newoptions } = formvalues;
      const boardDetails = {
        app_token: info.app_token,
        user_uuid: info.user_uuid,
        attribute_set_key: key,
        attribute_key: formvalues.field,
        attribute_label: formvalues.headerName,
        attribute_properties: newoptions,
      };

      if (gfinterval.current) {
        clearTimeout(gfinterval.current);
      }
      gfinterval.current = setTimeout(() => {
        dispatch(columnResize(boardDetails));
      }, 200);
    } else {
      return;
    }
  };
  const onGridReady = useCallback(
    (params, key = null, filter = null, search = "") => {
      if (
        params?.colDef?.field &&
        state.selectColumnsCheck.includes(params?.colDef?.field)
      ) {
        const check = document.querySelector(
          `[col-id="${params.column.colId}"]`
        );
        check
          .querySelectorAll(".filter-svg path")
          .forEach((ite) => (ite.style.stroke = "#18A0FB"));
      } else if (
        params?.colDef?.field &&
        state.selectColumnsCheck.includes(params?.colDef?.field) === false
      ) {
        const check = document.querySelector(
          `[col-id="${params.column.colId}"]`
        );

        check
          .querySelectorAll(".filter-svg path")
          .forEach((ite) => (ite.style.stroke = "grey"));
      }
      const querydata = document.querySelectorAll(".filter-svg");
      querydata.forEach((itt) => (itt.style.stroke = "grey"));
      if (state.selectColumnsCheck.length === 0) {
        document
          .querySelectorAll(".filter-svg path")
          .forEach((ite) => (ite.style.stroke = "grey"));
      }
      document
        .querySelectorAll(`.filter-svg path`)
        .forEach((ite) => (ite.style.stroke = "grey"));
      state.selectColumnsCheck.forEach((item) => {
        const check = document.querySelector(`[col-id="${item}"]`);
        if (check && check.querySelector(`.filter-svg path`)) {
          check
            .querySelectorAll(`.filter-svg path`)
            .forEach((ite) => (ite.style.stroke = "#18A0FB"));
        }
      });

      const datasource = {
        getRows: (param) => {
          const data = commonData.getCommonData();
          const ordering = { sort: "", column: "" };
          const { startRow, endRow, filterModel, sortModel, rowGroupCols } =
            param.request;
          const conditions = { ...state.conditions };
          const { title } = filterModel;
          let getRowsparamter = {};
          let url = `${info.apiUrl}tattle/rows`;
          //Sorting

          if (rowGroupCols.length) {
            getRowsparamter = {
              ...getRowsparamter,
              groupby: rowGroupCols[0].field,
            };
          }
          //Filtering
          const filterKeys = Object.keys(filterModel);
          filterKeys.forEach((filter) => {
            getRowsparamter = {
              ...getRowsparamter,
              [filter]: filterModel[filter]?.filterModels[0].filter,
              filter: { ...state.filterMod },
            };
          });
          //Pagination
          const page = endRow / state.perPage.pagination_default_value;
          getRowsparamter = {
            ...getRowsparamter,
            app_token: data.app_token,
            attribute_set_key: key || attrKey.current,
            // start: startRow,
            per_page: +state.perPage.pagination_default_value,
            sort: "sequence",
            order: "asc",
            current_page: param.api?.paginationProxy?.currentPage + 1,
            user_uuid: data.user_uuid,
            // end: endRow,
          };
          if (search || search === "null") {
            getRowsparamter = {
              ...getRowsparamter,
              app_token: data.app_token,
              attribute_set_key: key || attrKey.current,
              // start: startRow,
              per_page: +state.perPage.pagination_default_value,
              sort: "sequence",
              order: "asc",
              current_page: param.api?.paginationProxy?.currentPage + 1,
              search: search,
              user_uuid: data.user_uuid,
              // end: endRow,
            };
          }

          if (
            Object.keys(state.filterMod).length > 0 ||
            filter ||
            para.attribute_set_key
          ) {
            let filt = {};
            if (para.attribute_set_key) {
              filt[para.attribute_set_key.replace(/-/g, "_")] = +para.id;
            }
            getRowsparamter = {
              app_token: data.app_token,
              attribute_set_key: key || attrKey.current,
              filter: {
                ...filt,
                ...((Object.keys(state.filterMod).length > 0 &&
                  state.filterMod) ||
                  filter),
              },
              ...(ordering.column && {
                ["sort"]: ordering.column,
                ["order"]: ordering.sort,
              }),
              ...(state.globalSearch && {
                filter: {
                  ...filt,         
                  ...(state.globalSearch && {   
                    title: state.globalSearch 
                  })
                }
              }),
              per_page: +state.perPage.pagination_default_value,
              sort: "sequence",
              order: "asc",
              current_page: param.api?.paginationProxy?.currentPage + 1,
              user_uuid: data.user_uuid,
            };
          }
          if (sortModel.length) {
            const sortarr = [...conditions.sort];
            sortModel.forEach((item) => {
              const index = sortarr.findIndex((it) => {
                if (it) {
                  return Object.keys(it)[0] === Object.values(item)[1];
                }
              });
              if (index === -1) {
                sortarr.push({ [item.colId]: item.sort });
              } else {
                sortarr.splice(index, 1, { [item.colId]: item.sort });
              }
            });
            conditions.sort = sortarr;
            const { colId, sort } = sortModel[0];
            // url += `_sort=${colId}&_order=${sort}&`;
            ordering.sort = sort;
            ordering.column = colId;
            getRowsparamter = {
              ...getRowsparamter,
              sort: colId,
              order: sort,
            };
          }

          getRowsparamter = {
            ...getRowsparamter,
            filter: Object.entries(getRowsparamter.filter || {}).reduce((acc, [key, value]) => {
              if (value !== "" && value !== null && value !== undefined) {
                acc[key] = value;
              }
              return acc;
            }, {})
          };
          
          //url += `_start=${startRow}&per_page=${this.state.perPage.pagination_default_value}&_end=${endRow}`;
          param.api.showLoadingOverlay();
          fetch(url, {
            method: "post",
            body: JSON.stringify(getRowsparamter),
          })
            .then((httpResponse) => httpResponse.json())
            .then((response) => {
              if (!response.data.length) {
                param.api.showNoRowsOverlay();
              } else {
                param.api.hideOverlay();
              }

              setState((prev) => {
                return {
                  ...prev,
                  totalRecord: {
                    ...prev.totalRecord,
                    [key]: response.total_count,
                  },
                };
              });

              param.successCallback(response.data, response.total_count);
            })
            .catch((error) => {
              param.api.showNoRowsOverlay();
              param.failCallback();
            });
        },
      };
      gridrefval?.current?.api.setServerSideDatasource(datasource);
    },
    [
      state.key,
      state.filterMod,
      state.globalSearch,
      state.perPage.pagination_default_value,
    ]
  );
  const onRowValueChanged = async (data) => {
    // const userDetails = this.getCommonData();
    const { data: indata } = data;
    const { colDef } = data.column;
    let value = "";

    if (colDef.attribute_type === "assign_to") {
      const formdata = {
        app_token: info?.app_token,
        attribute_set_key: state.key,
        attribute_key: colDef.field,
        customer_tattle_uuid: indata.customer_tattle_uuid,
        attribute_type: colDef.attribute_type,
        attribute_value: data?.value,
        user_uuid: info?.user_uuid,
      };
      const resp = await apiHandler(colDef.attribute_type, formdata);
    } else if (colDef.attribute_type === "effort") {
      value = { effort_data: { [data.column.colId]: { ...data.value } } };

      let formdata = {
        app_token: info?.app_token,
        attribute_set_key: state.key,
        customer_tattle_uuid: indata.customer_tattle_uuid,
        ...value,
        user_uuid: info.user_uuid,
      };
      const resp = await apiHandler(colDef.attribute_type, formdata);
      if (resp.code === 200) {
        childBoardDataChanged();
      }
    } else if (colDef.attribute_type === "category") {
      const formdata = {
        app_token: info?.app_token,
        attribute_set_key: state.key,
        attribute_key: colDef.attribute_type,
        customer_tattle_uuid: indata.customer_tattle_uuid,
        category_id: data?.value,
        user_uuid: info?.user_uuid,
      };
      const resp = await apiHandler(colDef.attribute_type, formdata);
    } else if (colDef.attribute_type === "status") {
      const formdata = {
        app_token: info?.app_token,
        attribute_set_key: state.key,
        attribute_key: colDef.attribute_type,
        customer_tattle_uuid: indata.customer_tattle_uuid,
        status_id: data?.value,
        user_uuid: info?.user_uuid,
      };
      const resp = await apiHandler(colDef.attribute_type, formdata);
      if (resp.code === 200) {
        childBoardDataChanged();
      }
    } else {
      value = { [data.column.colId]: data.value };
      let formdata = {
        app_token: info?.app_token,
        attribute_set_key: state.key,
        product_key: process.env.REACT_APP_PRODUCT_KEY,
        customer_tattle_uuid: indata.customer_tattle_uuid,
        ...value,
        user_uuid: info?.user_uuid,
      };

      const resp = await apiHandler(null, formdata);
    }
  };
  const fetchBoardForm = async (key) => {
    const attrInfo = {
      app_token: info?.app_token,
      attribute_set_key: 'er',
      show_on_form: true,
      attribute_status: true,
    };

    try {
      setState((state) => {
        return {
          ...state,
          isLoading: true,
        };
      });
      const response = await fetch(`${commonData.commonData().apiUrl}tattle/attributes`, {
        method: "POST",
        body: JSON.stringify(attrInfo),

      });

      const rdata = await response.json();
      if (rdata.code === 200) {
        setState((state) => {
          return {
            ...state,
            isLoading: false,
          };
        });
        return { data: rdata.data };
      } else {
        return { data: rdata.data || [] };
      }
    } catch (error) {
      console.error(error);
      return { data: [] };
    }
  };

  useEffect(() => {
    
    if (!state.boardConfig?.category_board && !state.boardConfig?.isExternal) {
      const getColumns = child_board.filter(
        (item) => item.attribute_set_key === state.key
      );
      const getObj = getColumns.reduce((acculator, currentValue) => {
        return currentValue;
      }, {});

      setAttributes(getObj?.data?.forms);
    }
    else {
      fetchBoardForm(state.key).then((res) => {
        setAttributes(res.data || []);
      });
    }
  }, [state.key]);
  const getModalContent = () => {
    return (
      <>
        <form onSubmit={onSubmitAttachmentHandler}>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="file-select">
                <div className="file-select-name" id="noFile2">
                  <div>
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.4966 2.21875C10.6066 2.25362 7.84482 3.41715 5.80115 5.46082C3.75748 7.50449 2.59395 10.2663 2.55908 13.1562C2.59395 16.0462 3.75748 18.808 5.80115 20.8517C7.84482 22.8953 10.6066 24.0589 13.4966 24.0938C16.3866 24.0589 19.1483 22.8953 21.192 20.8517C23.2357 18.808 24.3992 16.0462 24.4341 13.1562C24.3992 10.2663 23.2357 7.50449 21.192 5.46082C19.1483 3.41715 16.3866 2.25362 13.4966 2.21875ZM19.7466 13.9375H14.2778V19.4062H12.7153V13.9375H7.24658V12.375H12.7153V6.90625H14.2778V12.375H19.7466V13.9375Z"
                        fill="#717171"
                      ></path>
                    </svg>
                  </div>
                  Add File
                </div>
                <input
                  type="file"
                  name="chooseFile"
                  id=""
                  title=""
                  multiple
                  onChange={attachmentUploadHandler}
                />
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="custom_image">
                <div className="afterupload-image">
                  {state.attachments.map((file, index) => {
                    const imgg = URL.createObjectURL(file);
                    return (
                      <div class="img-box">
                        <ImagePreview
                          headImage={imgg}
                          ext={file.name.split(".").pop()}
                          imgLength={state.attachments}
                          width="128px"
                          height="58px"
                        />

                        <figure>
                          {file?.name?.slice(0, 6) +
                            "." +
                            file?.name.split(".").pop()}
                        </figure>
                        <div
                          class="delete"
                          onClick={() => removeImageHandler(index, file.name)}
                        >
                          <svg
                            width="11"
                            height="10"
                            viewBox="0 0 11 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <title>Remove</title>
                            <path
                              d="M8.21973 2.5L3.21973 7.5"
                              stroke="#737373"
                              stroke-width="1.33"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M3.21973 2.5L8.21973 7.5"
                              stroke="#737373"
                              stroke-width="1.33"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {newarrayAll.length > 0 && (
                  <div className="image_failed_list">
                    {" "}
                    <ul>
                      {newarrayAll.map((item, index) => (
                        <li>
                          <Alert variant="danger">
                            {item.name} : {item.message}
                          </Alert>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="cancl-cls"
              data-bs-dismiss="modal"
              onClick={hideUiModal}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="submit-cls"
              disabled={state.mainImageUpload}
            >
              {state.mainImageUpload ? "Uploading..." : "Submit"}
            </button>
          </div>
        </form>
      </>
    );
  };
  const showModalPopupHandler = () => {
    setState((state) => {
      return {
        ...state,
        attachShow: true,
      };
    });
  };
  const hideUiModal = () => {
    setState((state) => {
      return {
        ...state,
        attachShow: false,
        attachments: [],
      };
    });
    newarrayAll = [];
  };
  const removeImageHandler = (index, name) => {
    const attachments = [...state.attachments];
    attachments.splice(index, 1);
    const alertError = [...newarrayAll];
    const indexr = alertError.findIndex((item) => item.name === name);
    alertError.splice(indexr, 1);
    newarrayAll = alertError;
    setState((state) => {
      return {
        ...state,
        attachments,
      };
    });
  };
  const getStoreData = (obj) => {
    const failedImagesIssue = [...newarrayAll];
    failedImagesIssue.push(obj);
    newarrayAll = failedImagesIssue;
  };
  const newPromiseUploader = (formdata) => {
    let newarr = [];
    const data = commonData.getCommonData();
    return new Promise((resolve, reject) => {
      axios
        .post(`${data.apiUrl}attachment/upload`, formdata, {
          headers: {
            "Content-Type": "multipart/formdata",
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            resolve(resp);
          } else {
            reject(resp);
          }
        })
        .catch((error) => {
          const arrnewcon = [...newarrayAll];
          if (arrnewcon.length > 0) {
            let newfile = arrnewcon.find((item) => {
              return (
                item.name.toLowerCase() ===
                formdata.get("image").name.toLowerCase()
              );
            });
            if (!newfile) {
              getStoreData({
                name: formdata.get("image").name,
                message: error.message,
              });
            }
          } else {
            getStoreData({
              name: formdata.get("image").name,
              message: error.message,
            });
          }
          reject(error);
        });
    });
  };
  const onSubmitAttachmentHandler = async (evt) => {
    evt.preventDefault();
    if (state.attachments.length > 0) {
      setState((state) => {
        return {
          ...state,
          mainImageUpload: true,
        };
      });
      const data = commonData.getCommonData();
      let newarray = [];
      const appPromis = state.attachments.map((file) => {
        let formdata = new FormData();
        formdata.append("app_token", data.app_token);
        formdata.append("product_key", process.env.REACT_APP_PRODUCT_KEY);
        formdata.append(`image`, file);
        const result = newPromiseUploader(formdata);
        result.then((resp) => {
          if (resp.data.code === 400 || resp.data.code === 1208) {
            const arrnewcon = [...newarrayAll];
            if (arrnewcon.length > 0) {
              let newfile = arrnewcon.find((item) => {
                return item.name.toLowerCase() === file.name.toLowerCase();
              });
              if (!newfile) {
                getStoreData({
                  name: file.name,
                  message: resp.data.message,
                });
              }
              // return;
            } else {
              getStoreData({
                name: file.name,
                message: resp.data.message,
              });
            }
          }
        });
        return result;
      });

      const request = await Promise.allSettled(appPromis);
      if (request.length > 0) {
        let newfilearray = {};
        request.forEach((it) => {
          if (it.status === "fulfilled") {
            const {
              data: { data },
            } = it.value;
            newfilearray = { ...newfilearray, ...data };
          } else {
          }
        });

        if (
          newfilearray &&
          request.every(
            (item) =>
              item.status === "fulfilled" && item.value.data.code === 200
          )
        ) {
          setTimeout(() => {
            setState((state) => {
              return {
                ...state,
                attachments: [],
                saveImageFile: { ...state.saveImageFile, ...newfilearray },
                attachShow: false,
                mainImageUpload: false,
              };
            });
          }, 200);

          // this.props.saveAttachment({ attachments: newfilearray });
        } else {
          setState((state) => {
            return { ...state, attachShow: true, mainImageUpload: false };
          });
        }
      }
    }
  };
  // function for save the upload image

  const uploadErImages = async (storyid) => {
    let images;
    if (Object.keys(state.saveImageFile).length > 0) {
      images = state.saveImageFile;
    } else {
      images = state.attachImages;
    }
    const savedata = {
      app_token: info.app_token,
      attribute_set_key: state.categoryBboardID ? 'er' : state.key,
      attachment: images,
      customer_tattle_uuid: storyid,
    };
    const resp = await fetch(`${info.apiUrl}update-attachment-data`, {
      method: "post",
      body: JSON.stringify(savedata),
    });
    const rdata = await resp.json();
    if (rdata.code === 200) {
      setState((prevState) => {
        return {
          ...prevState,
          saveImageFile: {},
          attachImages: {},
        };
      });
    }
  };
  const removeChildErStory = () => {
    setState((state) => {
      return {
        ...state,
        deleteChildRecord: true,
      };
    });
  };

  const toggleInputHandler = (formik, evt, item) => {
    const { name, value } = evt.target;
    formik.setFieldValue(
      name,
      value === "false" || value === "" ? true : false
    );
  };

  useEffect(() => {
    (async () => {
      let response;
      if (state.deleteChildRecord && state.deleteId) {
        if(state.boardConfig?.isExternal && state.boardConfig?.attribute_set_key){
          response = await fetch(`${info.apiUrl}/project/update`, {
            method: "POST",
            body: JSON.stringify({
              app_token: info.app_token,
              attribute_set_key: para.attribute_set_key,
              customer_tattle_uuid: +para.id,
              project: {
                [state.boardConfig.attribute_set_key]: [state.deleteId]
              },
              user_uuid: info.user_uuid,
              operation: "delete_only"

            }),
          });
          }else{
          response = await fetch(`${info.apiUrl}tattle/remove`, {
          method: "post",
          body: JSON.stringify({
            app_token: info.app_token,
            customer_tattle_uuid: state.deleteId,
            attribute_set_key: attrKey.current || state.key,
            user_uuid: info.user_uuid,
            parent_attribute_set_key,
          }),
        });
        }

       
        const rdata = await response.json();
        if (rdata.code === 200) {
          childBoardDataChanged();
          setState((state) => {
            return {
              ...state,
              showModal: false,
              deleteChildRecord: false,
            };
          });
           if(state.boardConfig.isExternal){
            callRowApi(state.key);
          }else{
            onGridReady(state.gridApi, attrKey.current || state.key);
          }
          const newhistory = await dispatch(
            getBoardHistory(
              {
                app_token: info.app_token,
                attribute_set_key: parent_attribute_set_key,
                customer_tattle_uuid: +para.id,
                attribute_set_type,
              },
              "status"
            )
          );
          if (newhistory.code == 200) {
            getHistoryData(newhistory);
          }
        }
      }
    })();
  }, [state.deleteChildRecord]);

  useEffect(() => {
    if (state.deselectAll) {
      gridrefval.current?.api?.deselectAll();
      setState((state) => {
        return {
          ...state,
          deselectAll: false,
        };
      });
    }
  }, [state.deselectAll]);
  const submitandopenmodalform =async (formik) => {
    const {values} = formik;
      // Validate the form
  const errors = await formik.validateForm();
  
  if (Object.keys(errors).length > 0) {
    formik.setTouched(errors); // Mark fields as touched
    return; // Stop submission if errors exist
  }

    if(state.showEditForm){
      editFormSubmitHandler(values, (key)=>{
        callRowApi(key);
        
      setState((state) => {
        return {
          ...state,
          showEditForm: true,
        };
      })
      
    })}else{
      formSubmitHandler(values, (key)=>{
        callRowApi(key);
        setShowCanvas(true);
        formik.resetForm();
      })
    }
 
    
   
  }
  const editFormSubmitHandler = async (values,isReturn=null) => {
    setState((state) => {
      return {
        ...state,
        isAdding: true,
      };
    });

    let valuesforupdate = {
      ...values,
      app_token: info.app_token,
      user_uuid: info.user_uuid,
      attribute_set_key: state.key,
      product_key: process.env.REACT_APP_PRODUCT_KEY,
      attribute_set_name: state.keyname,
      customer_tattle_uuid: state.childBoardId,
      [para.attribute_set_key]: +para.id,
      parent_attribute_set_key,
    };
    const { attachment, ...othervalues } = valuesforupdate;
    const resp = await fetch(`${info.apiUrl}tattle/update`, {
      method: "post",
      body: JSON.stringify(othervalues),
    });

    const rdata = await resp.json();
    const { code, data, status, message } = rdata;
    if (code === 200) {
      if (Object.keys(state.saveImageFile).length > 0) {
        uploadErImages(data.customer_tattle_uuid);
      }
      if( typeof isReturn == "function") { return isReturn(state.key)}
            setState((prev) => {
        return {
          ...prev,
          showEditForm: false,
          isAdding: false,
          // createBoard: {
          //   ...prev.createBoard,
          //   board: true,
          //   title: status,
          //   message: message,
          //   bg: "primary",
          // },
        };
      });

      const newhistory = await dispatch(
        getBoardHistory(
          {
            app_token: info.app_token,
            attribute_set_key: parent_attribute_set_key,
            customer_tattle_uuid: +para.id,
            attribute_set_type,
          },
          "status"
        )
      );
      if (newhistory.code == 200) {
        getHistoryData(newhistory);
      }
      onGridReady(state.gridApi, attrKey.current || state.key);
    }
  };
  const removeNoteImages = (id) => {
    const newimage = {
      ...delete state.attachImages[id],
      ...state.attachImages,
    };
    dispatch(removeChildBoardImage(id));
    setState((state) => {
      return { ...state, attachImages: newimage };
    });
  };

  const getBlobImages = (images, ind) => {
    const blob = images?.file_url;
    const ext = images?.file_name?.split(".").pop();
    const allow_images = ["jpg", "png", "jpeg"];

    return (
      <div className="img-box">
        {allow_images.includes(ext) ? (
          <img
            src={blob}
            className="img-fluid"
            style={{
              cursor: "pointer",
              marginRight: "3px",
            }}
            onClick={() => this.previewImage(blob)}
          />
        ) : (
          <i className="fa fa-file" style={{ fontSize: "40px" }}></i>
        )}
        {/* <figure>
          {images?.file_name?.slice(0, 6) +
            "..." +
            images?.file_name?.slice(images?.file_name.length - 1, 6) +
            "." +
            ext}
        </figure> */}
        <div className="delete" onClick={() => removeNoteImages(ind)}>
          <span>
            <svg
              width="11"
              height="10"
              viewBox="0 0 11 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.21973 2.5L3.21973 7.5"
                stroke="#737373"
                stroke-width="1.33"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M3.21973 2.5L8.21973 7.5"
                stroke="#737373"
                stroke-width="1.33"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </span>
        </div>
      </div>
    );
  };
  const removeImageFromErEdit = () => {
    setState((state) => {
      return {
        ...state,
        removeEditErImage: true,
      };
    });
  };
  const perPageSizeChange = (evet) => {
    setState((state) => {
      return {
        ...state,
        perPage: {
          ...state.perPage,
          pagination_default_value: evet.target.value,
        },
      };
    });
  };

  useEffect(() => {
    onGridReady(gridrefval.current, state.key); 
  }, [state.perPage.pagination_default_value]);
  const externalWindowViewCustomModal = () => {
    setState((state) => {
      return {
        ...state,
        isFullScreenView: true,
      };
    });
  };
  useEffect(() => {
    (async () => {
      if (state.removeEditErImage) {
        const details = {
          app_token: info.app_token,
          user_uuid: info.user_uuid,
          attribute_set_key: state.key,
          customer_tattle_uuid: state.childBoardId,
          attribute_key: "attachment",
          file_uuid: state.attachment_uuid,
        };

        try {
          const resp = await fetch(`${info.apiUrl}attachment/delete`, {
            method: "post",
            body: JSON.stringify(details),
          });

          const rdata = await resp.json();
          if (rdata.code === 200) {
            setState((state) => {
              return {
                ...state,
                showModalEditRemove: false,
                removeEditErImage: false,
              };
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    })();
  }, [state.removeEditErImage]);

  const removeErEditImage = (image) => {
    setState((state) => {
      return {
        ...state,
        showModalEditRemove: true,
        attachment_uuid: image,
      };
    });
    const editFormsAttachment = { ...state.editForm };
    editFormsAttachment.attachment = {
      ...delete editFormsAttachment["attachment"][image],
      ...editFormsAttachment.attachment,
    };

    setState((state) => {
      return {
        ...state,
        ...editFormsAttachment,
      };
    });
  };
  useEffect(() => {
    setTimeout(() => {
      state.selectColumnsCheck.forEach((item) => {
        const check = document.querySelector(`[col-id="${item}"]`);
        if (check) {
          check
            .querySelectorAll(".filter-svg path")
            .forEach((ite) => (ite.style.stroke = "#18A0FB"));
        }
      });
    }, 100);
  }, [state.selectColumnsCheck]);

  const  getTotalHours = (days, hours) => {
    let total = 0;
    if (days && hours) {
      total = +days * 8 + +hours;
    } else if (days) {
      total = +days * 8;
    } else if (hours) {
      total = +hours;
    }
    return total;
  };
  const getFormattedValue = (item, values) => {

    const { effort_in_days = 0, effort_in_hours = 0 } = values[item] || {};

    let effort = {
      total_hours: getTotalHours(effort_in_days, effort_in_hours),
      effort_in_days: +effort_in_days || 0,
      effort_in_hours: +effort_in_hours || 0,
    };
   
    return effort;
  };

  // form submit create new ER

  const formSubmitHandler = useCallback(
    async (values, isReturn=null) => {
      let currenttattle = { ...boardvalue.current };
      let rel_type = state.relation_type;
      const valData = {
        ...values,
        app_token: info.app_token,
        user_uuid: info.user_uuid,
        attribute_set_key: state.key,
        attribute_set_name: state.keyname,
        ...currenttattle,
        [para.attribute_set_key]: [+para.id],
        ...( !main_attribute_set_key ? { parent_attribute_set_key } : {} ),
      };


      Object.keys(valData).forEach((key) => {
        const attr = attributes.find(a => a.field === key);
      
        if (attr && attr.attribute_type === "effort") {
          valData[key] = getFormattedValue(key, values);
        }
      });
      

      const { attachment, ...rest } = valData;
      const rest_att_set = rest.attribute_set_key;
      if (state.boardConfig.category_board) {
        rest.attribute_set_key = "er";
        rest.attribute_set_name = "ER";
      }
      setState((state) => {
        return {
          ...state,
          isAdding: true,
        };
      });

      const response = await fetch(`${info.apiUrl}tattle/create`, {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(rest),
      });
      const rdata = await response.json();
      const { code, data } = rdata;
      if (code === 200) {
        if (Object.keys(state.saveImageFile).length > 0) {
          uploadErImages(data.customer_tattle_uuid);
        }
        setState((state) => {
          return {
            ...state,
            // createBoard: {
            //   ...state.createBoard,
            //   board: true,
            //   message: `${rest.attribute_set_key} created successfully`,
            //   title: rdata.status,
            //   bg: "primary",
            // },
            isAdding: false,
            related_tattle_id: data.customer_tattle_uuid,
          };
        });

        if (state.boardConfig && state.boardConfig?.category_board) {
          addRelationHandler(data.customer_tattle_uuid);
        }
        callRowApi(state.key, state.relationType);
        if (typeof isReturn == "function") { return isReturn(state.key) }
        setShowCanvas(false);
        const newhistory = await dispatch(
          getBoardHistory(
            {
              app_token: info.app_token,
              attribute_set_key: parent_attribute_set_key,
              customer_tattle_uuid: +para.id,
              attribute_set_type,
            },
            "status"
          )
        );
        if (newhistory.code == 200) {
          getHistoryData(newhistory);
        }
      } else {
        setState((state) => {
          return {
            ...state,
            createBoard: {
              ...state.createBoard,
              board: true,
              message: rdata.message,
              title: rdata.status,
              bg: "danger",
            },
            isAdding: false,
          };
        });
      }
    },
    [state.key, state.saveImageFile]
  );
  const getOptionsForAsync = useCallback(
    async (url, evt, type = null, field = null) => {
      if (type === "pod_department" || type === "product") {
        if (evt && state.defaultAsyncValue[type]) {
          return state.defaultAsyncValue[type].filter((item) =>
            item.label.toLowerCase().includes(evt.toLowerCase())
          );
        }
        const response = await fetch(`${url}`);
        const rdata = await response.json();
        const options = rdata.map((item) => ({
          label: item.value,
          value: item.id,
        }));

        setState((state) => {
          return {
            ...state,
            defaultAsyncValue: { [type]: options },
          };
        });
        return options;
      }
    },
    [state.defaultAsyncValue]
  );
  const deleteChild = async (id) => {
    setState((state) => {
      return {
        ...state,
        showModal: true,
        deleteId: id,
      };
    });
  };

  const attachmentUploadHandler = (evt) => {
    const files = evt.target.files;
    const attachments = [...state.attachments];
    for (let i = 0; i < files.length; i++) {
      attachments.push(files[i]);
    }
    setState((state) => {
      return {
        ...state,
        attachments,
      };
    });
  };

  // file upload function
  const onFileChangeHandler = (evt) => {
    const attachments = [...evt.target.files];

    // image array upload with prmise
    const erImageUpload = attachments.map((file) => {
      let formdata = new FormData();
      formdata.append("app_token", info.app_token);
      formdata.append("product_key", process.env.REACT_APP_PRODUCT_KEY);
      formdata.append("image", file);
      setState((state) => {
        return {
          ...state,
          isImageUpload: true,
        };
      });
      return new Promise((resolve, reject) => {
        axios
          .post(`${info.apiUrl}attachment/upload`, formdata, {
            headers: {
              "Content-type": "multipart/formdata",
            },
          })
          .then((resp) => {
            const { data } = resp;
            if (data.code === 200) {
              return resolve(resp);
            } else {
              return reject(resp);
            }
          })
          .catch((error) => {
            setState((prevState) => {
              return {
                ...prevState,
                // attachmentUpload: attachmentupload,
                isImageUpload: false,
                createBoard: {
                  ...prevState.createBoard,
                  title: "Error",
                  message: error.message,
                  bg: "danger",
                  board: true,
                },
              };
            });
            return reject(error);
          });
      });
    });

    const allPro = Promise.allSettled(erImageUpload);
    allPro
      .then((pro) => {
        return Promise.allSettled(pro);
      })
      .then((ss) => {
        ss.forEach((item) => {
          const { status, value } = item;
          if (value && value.status === "fulfilled") {
            setState((prevState) => {
              return {
                ...prevState,
                saveImageFile: {
                  ...prevState.saveImageFile,
                  ...value?.value?.data?.data,
                },
                isImageUpload: false,
              };
            });
          }
        });
      });
  };
  const effortChangeHandler = (formik, evt, api_url, item) => {
    const value = +evt.target.value;

    const regex = /^\d*$/;

    if (evt.target.name == `effort_in_hours` && +value > 8) {
      return;
    }
    if (evt.target.name == `effort_in_days` && +value > 99) {
      return;
    }

    let neweffort = { ...formik.values[item.field], [evt.target.name]: +value };

    if ("effort_in_days" in neweffort || "effort_in_hours" in neweffort) {
      neweffort = {
        ...neweffort,
        total_hours:
          (neweffort.effort_in_days || 0) * 8 +
          (neweffort.effort_in_hours || 0),
      };

      let maxKey = null;
      let maxHours = -Infinity;

      for (const key in item?.options) {
        if (neweffort.total_hours > item.options[key].total_hours) {
          neweffort = {
            ...neweffort,
            effort: key,
          };
        }
      }
    }

    if (regex.test(value) || value === "") {
      formik.setFieldValue(item.field, neweffort);
    }
  };
  const getReletedTattleIdHandler = (id) => {
    setState((state) => {
      return {
        ...state,
        errorRelation: {
          ...state.errorRelation,
          relationId: "",
        },
        related_tattle_id: id,
      };
    });
  };
  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        attachImages: boardAttr.child_board_images_edit || {},
      };
    });
  }, [boardAttr.child_board_images_edit]);

  const removeImage = (ind) => {
    const attachments = [...state.attachments];
    attachments.splice(ind, 1);
    setState((state) => {
      return {
        ...state,
        attachments: attachments,
      };
    });
  };

  const removeEditUploadImage = async (uuid) => {
    setState((state) => {
      return {
        ...state,
        showModal: true,
        removeEditImageUuid: uuid,
      };
    });
  };
  const convertDateFormat = (date) => {
    let convertdate = date ? moment(date).format("YYYY-MM-DD") : "";
    return convertdate;
  };
  useEffect(() => {
    (async () => {
      if (state.removeEditImageUuid && state.deleteChildRecord) {
        const editStatedata = { ...state.editForm };
        editStatedata.attachment = {
          ...delete editStatedata.attachment[state.removeEditImageUuid],
          ...editStatedata.attachment,
        };

        const response = await fetch(`${info.apiUrl}attachment/delete`, {
          method: "POST",
          body: JSON.stringify({
            app_token: info.app_token,
            user_uuid: info.user_uuid,
            attribute_key: "attachment",
            attribute_set_key: state.key,
            customer_tattle_uuid: +state.childBoardId,
            file_uuid: state.removeEditImageUuid,
          }),
        });

        const rdata = await response.json();
        if (rdata.code === 200) {
          setState((state) => {
            return {
              ...state,
              editForm: editStatedata,
              attachImages: editStatedata.attachment,
              showModal: false,
              removeEditImageUuid: "",
              deleteChildRecord: false,
              // createBoard: {
              //   ...state.createBoard,
              //   board: true,
              //   message: rdata.message,
              //   title: "success",
              //   bg: "primary",
              // },
            };
          });
          // callRowApi(state.key);
        } else {
          setState((state) => {
            return {
              ...state,
              createBoard: {
                ...state.createBoard,
                board: true,
                message: rdata.message,
                title: "failure",
                bg: "danger",
              },
            };
          });
        }
      }
    })();
  }, [state.deleteChildRecord]);
  // return ui for er

  const getPopulateFormData = (
    field = attributes || "",
    data = state.editForm || {}
  ) => {
    const fields = [];
    attributes.length > 0 &&
      attributes.forEach((item) => {
        let validation = {};
        if (item.is_required && item.attribute_type === "tel") {
          const phoneRegExp =
            /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
          validation = {
            required: string()
              .required(
                commonData.firstUpper(item.headerName + " is required ")
              )
              .matches(phoneRegExp, "Phone number is not valid")
              .max(10, "10 number is allowed"),
          };
        } else if (item.is_required && item.attribute_type === "text") {
          validation = {
            required: string()
              .trim()
              .required(
                commonData.firstUpper(item.headerName + " is required ")
              ),
          };
        } else if (item.is_required && item.attribute_type === "textarea") {
          validation = {
            required: string()
              .trim()
              .test("has text", item.headerName + " is required ", (value) => {
                // value && value?.replace(/<\/?[^>]+(>|$)/g, "").trim()
                const strippedValue =
                  value && value.replace(/<\/?[^>]+(>|$)/g, "").trim();
                return (
                  strippedValue?.replace(/&nbsp;|<[^>]+>/g, "").trim() !== ""
                ); // Return tru
              })
              .required("This field is required."),
          };
        } else if (item.is_required && item.attribute_type === "select") {
          validation = {
            required: item.is_multiple
              ? array()
                  .min(1)
                  .required(
                    commonData.firstUpper(item.headerName + " is required ")
                  )
              : string()
                  .required(
                    commonData.firstUpper(item.headerName + " is required ")
                  )
                  .transform((value) => {
                    return value && !Array.isArray(value) ? value : value[0];
                  }),
          };
        } else if (item.is_required && item.attribute_type === "priority") {
          validation = {
            required: item.is_multiple
              ? array()
                  .min(1)
                  .required(
                    commonData.firstUpper(item.headerName + " is required ")
                  )
              : string().required(
                  commonData.firstUpper(item.headerName + " is required ")
                ),
          };
        } else if (item.is_required && item.attribute_type === "checkbox") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required ")
            ),
          };
        } else if (item.attribute_type === "number") {
          if (item.is_required) {
            validation = {
              required: number()
                .required(
                  commonData.firstUpper(item.headerName + " is required ")
                )
                .min(0),
            };
          } else {
            validation = {
              required: number()
                .min(
                  0,
                  commonData.firstUpper(
                    item.headerName + " must be equal or greater than 0"
                  )
                )
                .nullable(true)
                .transform((_, val) => (val ? Number(val) : null)),
            };
          }
        } else if (item.is_required && item.attribute_type === "radio") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required ")
            ),
          };
        } else if (item.is_required && item.attribute_type === "date") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required ")
            ),
          };
        } else if (item.is_required && item.attribute_type === "start_date") {
          validation = {
            required: date().required(item.headerName + " is required"),
          };
        } else if (item.attribute_type === "start_date") {
          validation = {
            required: date()
              .nullable()
              .transform((v) => (v instanceof Date && !isNaN(v) ? v : null)),
          };
        } else if (item.is_required && item.attribute_type === "end_date") {
          validation = {
            required: date().required(item.headerName + " is required"),
          };
        } else if (item.attribute_type === "end_date") {
          validation = {
            required: date()
              .typeError(item.headerName + " is required")
              .nullable()
              .transform((v) => (v instanceof Date && !isNaN(v) ? v : null)),
          };
        } else if (item.is_required && item.attribute_type === "api") {
          if (item.is_multiple) {
            validation = {
              required: array().required(
                commonData.firstUpper(item.headerName + " is required ")
              ),
            };
          } else {
            validation = {
              required: string().required(
                commonData.firstUpper(item.headerName + " is required ")
              ),
            };
          }
        } else if (item.is_required && item.attribute_type === "assign_to") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required ")
            ),
          };
        } else if (item.is_required && item.attribute_type === "customer") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required ")
            ),
          };
        } else if (item.is_required && item.attribute_type === "assign_to") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required ")
            ),
          };
        } else if (item.is_required && item.attribute_type === "status") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required ")
            ),
          };
        } else if (item.is_required && item.attribute_type === "board") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required ")
            ),
          };
        } else if (item.attribute_type === "email") {
          validation = {
            required: string().email("Invalid Email"),
          };
        }
        else if (item.is_required && item.attribute_type === "category") {
          validation = {
            required: string().required(
              commonData.firstUpper(item.headerName + " is required ")
            ),
          };
        }
        fields.push({
          name: item.field,
          initialValue: "",
          type: item.attribute_type,
          ...validation,
        });
      });
    const initialValues = Object.fromEntries(
      fields.map((fiel) => [fiel.name, fiel.initialValue || data[fiel.name]])
    );

    const validObject = Object.fromEntries(
      fields.map((fiel) => [fiel.name, fiel.required])
    );
    const userSchema = object().shape(validObject);
    const customStyles = {
      menuList: (style, state) => {
        const height = state.selectProps.inputValue
          ? "auto"
          : state.options.length > 5
          ? "180px"
          : "auto";
        return {
          ...style,
          overflowY: "auto",
          height: height,
        };
      },
    };

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={userSchema}
        onSubmit={(values, { resetForm }) => {
          Object.values(state.editForm).length > 0
            ? editFormSubmitHandler(values)
            : formSubmitHandler(values);
          // resetForm({ values: "" });
        }}
      >
        {(formik) => {
          return (
            <Form>
              {attributes.length > 0 &&
                attributes.map((item, index) => {
                  if (item.attribute_type === "text") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name={item.field}
                            ref={(el) => (focusRef.current[index] = el)}
                            value={formik.values[item.field] || ""}
                            onChange={(evt) =>
                              formik.setFieldValue(item.field, evt.target.value)
                            }
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            autoComplete="off"
                          />
                          {item?.min_length &&
                            formik.values[item.field] &&
                            formik.touched[item.field] &&
                            formik.values[item.field].replace(/<[^>]+>/g, "").trim().length <
                            Number(item.min_length) && (
                              <p className="input-warning">
                                <i className="fas fa-exclamation-triangle"></i>
                                The recommended {item.headerName.toLowerCase()} length is at least{" "}
                                {item.min_length} characters.
                              </p>
                            )}
                        </div>

                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "api") {
                    // const options = Object.keys(item.options).map((ite) => ({
                    //   label: item.options[ite].name,
                    //   value: item.options[ite].user_uuid,
                    //   profile: item.options[ite].profile_image,
                    // }));

                    // const valassi = options.filter(
                    //   (nt) => nt.value == formik.values[item.field]
                    // );
                    const valassi = state.defaultAsyncValue[item.field]?.filter(
                      (nt) => nt.value == formik.values[item.field]
                    );
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>

                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            value={valassi}
                            ref={(el) => (focusRef.current[index] = el)}
                            onChange={(value) => {
                              formik.setFieldValue(
                                item.field,
                                !value ? "" : value.value
                              );
                            }}
                            isClearable
                            loadOptions={(evt) => {
                              return getOptionsForAsync(
                                item.api_url,
                                evt,
                                item.field
                              );
                            }}
                            styles={customStyles}
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "customer") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <AsyncSelect
                            cacheOptions
                            ref={(el) => (focusRef.current[index] = el)}
                            defaultOptions
                            onChange={(value) => {
                              formik.setFieldValue(item.field, value.value);
                            }}
                            loadOptions={(evt) => {
                              return getOptionsForAsync(item.api_url, evt);
                            }}
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "er") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            ref={(el) => (focusRef.current[index] = el)}
                            onChange={(value) => {
                              formik.setFieldValue(item.field, value.value);
                            }}
                            styles={customStyles}
                            loadOptions={(evt) => {
                              return getOptionsForAsync(item.api_url, evt);
                            }}
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "assign_to") {
                    const { Option } = components;
                    let valassi;
                    if (item.defaultvalue && !formik.values[item.field]) {
                      valassi = state.users?.filter(
                        (nt) => nt.value == commonData.getCommonData().user_uuid
                      );
                      setTimeout(() => {
                        formik.setFieldValue(
                          item.field,
                          commonData.getCommonData().user_uuid
                        );
                      }, 200);
                    } else {
                      valassi = state.users?.filter((nt) => {
                        if (nt.value) {
                          return nt.value == formik.values[item.field];
                        }
                      });
                    }

                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            ref={(el) => (focusRef.current[index] = el)}
                            loadOptions={(evt) =>
                              getPeoplesCall(evt, item.api_url)
                            }
                            isClearable
                            components={{ Option: CustomOption }}
                            onChange={(value) => {
                              formik.setFieldValue(
                                item.field,
                                !value ? "" : value.value
                              );
                            }}
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            menuPlacement="auto"
                            value={valassi || ""}
                            styles={customStyles}
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "select") {
                    const options =
                      item.options &&
                      item.options.map((sel) => ({
                        label: sel.option_name,
                        value: sel._id,
                      }));
                    let vall = options.find(
                      (nio) => nio.value == formik.values[item.field]
                    );
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <ReactSelect
                            onChange={(value) => {
                              formik.setFieldValue(
                                item.field,
                                !value ? "" : value.value
                              );
                            }}
                            ref={(el) => (focusRef.current[index] = el)}
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            menuPlacement="auto"
                            isClearable
                            value={vall || ""}
                            styles={customStyles}
                            options={options}
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "toggle") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          {" "}
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >{`${commonData.firstUpper(item.headerName)}`}</label>
                          <div class="form-check form-switch me-1">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              role="switch"
                              name={`${item.field}`}
                              value={formik.values?.[item.field] || false}
                              onChange={(evt) =>
                                toggleInputHandler(formik, evt, item)
                              } // defaultValue={
                              //   editField.rows[editField.field]
                              // }
                              // onChange={editField.toggleHandler}
                              id="flexSwitchCheckChecked"
                              // value={
                              //   Boolean(
                              //     editField.rows[
                              //       editField.field
                              //     ]
                              //   ) || false
                              // }
                              checked={formik.values?.[item.field]}
                            />
                            <label
                              class="form-check-label"
                              for="flexSwitchCheckChecked"
                            ></label>
                          </div>
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "effort") {
                    // const options = item?.options?.map(
                    //   (item) => ({
                    //     ...item,
                    //     label: item.option_name,
                    //     value: item._id,
                    //   })
                    // );
                    // if (
                    //   this.state.allEfforts.length == 0 &&
                    //   this.state.users.length > 0
                    // ) {
                    //   this.getCallEffortApi(item.api_url);
                    // }
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <div className="input-group">
                            <div className="groupday">
                              {" "}
                              <input
                                type="text"
                                className="form-control effort-fields"
                                value={
                                  formik.values?.[item.field]?.[
                                    "effort_in_days"
                                  ] || 0
                                }
                                name={`effort_in_days`}
                                onChange={(evt) =>
                                  effortChangeHandler(
                                    formik,
                                    evt,
                                    item.api_url,
                                    item
                                  )
                                }
                                autoComplete="off"
                              />
                            </div>
                            <div className="grouphour">
                              {" "}
                              <input
                                type="text"
                                className="form-control effort-fields"
                                value={
                                  formik.values?.[item.field]?.[
                                    "effort_in_hours"
                                  ] || 0
                                }
                                name={`effort_in_hours`}
                                onChange={(evt) =>
                                  effortChangeHandler(
                                    formik,
                                    evt,
                                    item.api_url,
                                    item
                                  )
                                }
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "priority") {
                    const options =
                      item.options &&
                      item.options.map((sel) => ({
                        label: sel.option_name,
                        value: sel._id,
                      }));
                    let vall = "";
                    if (item.defaultvalue && !formik.values[item.field]) {
                      vall = options.filter(
                        (nio) => nio.value == item.defaultvalue
                      );
                      setTimeout(() => {
                        formik.setFieldValue(item.field, item.defaultvalue);
                      }, 300);
                    } else {
                      vall = options.filter(
                        (nio) => nio.value == formik.values[item.field]
                      );
                    }
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <ReactSelect
                            onChange={(value) => {
                              formik.setFieldValue(
                                item.field,
                                !value ? "" : value.value
                              );
                            }}
                            ref={(el) => (focusRef.current[index] = el)}
                            menuPlacement="auto"
                            isClearable
                            value={vall}
                            styles={customStyles}
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            options={options}
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "status" && item.show_on_form) {
                    const options = item.options.map((ite) => ({
                      label: ite.name,
                      value: ite._id,
                    }));
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <ReactSelect
                            value={formik.values[item.field] || []}
                            isMulti={true}
                            onChange={(value) => {
                              formik.setFieldValue(item.field,  value.map(it => it));
                            }}
                            ref={(el) => (focusRef.current[index] = el)}
                            menuPlacement="auto"
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            options={options}
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "email") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <input
                            value={formik.values[item.field]}
                            type={"email"}
                            ref={(el) => (focusRef.current[index] = el)}
                            className="form-control"
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "textarea") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <DraftjsInline
                            key={index}
                            editorState={formik.values[item.field] || ""}
                            value={formik.values[item.field] || ""}
                            field={item.field}
                            ref={(el) => (focusRef.current[index] = el)}
                            formik={formik}
                            onChange={(newEditorState) => {
                              formik.setFieldValue(item.field, newEditorState);
                            }}
                            onBlur={() => {
                              formik.setFieldTouched(item.field, true);
                            }}
                          />
                          {item?.min_length &&
                            formik.touched[item.field] &&
                            formik.values[item.field] &&
                            formik.values[item.field].replace(/<[^>]+>/g, "").trim().length <
                            Number(item.min_length) && (
                              <p className="description-warning">
                                <i className="fas fa-exclamation-triangle"></i>
                                The recommended {item.headerName.toLowerCase()} length is at least {item.min_length} characters.
                              </p>
                            )}
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "date") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <input
                            value={formik.values[item.field]}
                            type={"date"}
                            ref={(el) => (focusRef.current[index] = el)}
                            className="form-control"
                            onChange={(evt) =>
                              formik.setFieldValue(item.field, evt.target.value)
                            }
                            // min={new Date().toISOString().split("T")[0]}
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "start_date") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <ReactDatePicker
                            className="rasta-stripes"
                            ref={(el) => (focusRef.current[index] = el)}
                            selected={
                              formik.values[item.field]
                                ? new Date(formik.values[item.field])
                                : null
                            }
                            minDate={
                              formik.values[item.field]
                                ? new Date(formik.values[item.field]).setDate(
                                    new Date(
                                      formik.values[item.field]
                                    ).getDate() - 30
                                  )
                                : new Date().setDate(new Date().getDate() - 30)
                            }
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            isClearable
                            onChange={(evt) => {
                              let date = convertDateFormat(evt);
                              if (
                                formik.values["end_date"] &&
                                date > formik.values["end_date"]
                              ) {
                                setState((state) => {
                                  return {
                                    ...state,
                                    createBoard: {
                                      ...state.createBoard,
                                      board: true,
                                      bg: "danger",
                                      title: "error",
                                      message:
                                        "Start date shouldn't greater than End date",
                                    },
                                  };
                                });
                                return;
                              }
                              formik.setFieldValue(item.field, date);
                            }}
                            placeholderText="dd-mm-yyyy"
                            dateFormat={"dd-MM-yyyy"}
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "end_date") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <ReactDatePicker
                            className="rasta-stripes"
                            ref={(el) => (focusRef.current[index] = el)}
                            selected={
                              formik.values[item.field]
                                ? new Date(formik.values[item.field])
                                : null
                            }
                            isClearable
                            onChange={(evt) => {
                              let date = convertDateFormat(evt);
                              formik.setFieldValue(item.field, date);
                            }}
                            minDate={
                              formik.values["start_date"]
                                ? new Date(formik.values["start_date"])
                                : new Date().setDate(new Date().getDate() - 30)
                            }
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            placeholderText="dd-mm-yyyy"
                            dateFormat={"dd-MM-yyyy"}
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {" "}
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "go_live_date") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <ReactDatePicker
                            className="rasta-stripes"
                            ref={(el) => (focusRef.current[index] = el)}
                            selected={
                              formik.values[item.field]
                                ? new Date(formik.values[item.field])
                                : null
                            }
                            isClearable
                            onChange={(evt) =>
                              formik.setFieldValue(
                                item.field,
                                convertDateFormat(evt)
                              )
                            }
                            minDate={
                              formik.values["end_date"]
                                ? new Date(formik.values["end_date"])
                                : new Date().setDate(new Date().getDate() - 30)
                            }
                            onBlur={() =>
                              formik.setFieldTouched(item.field, true)
                            }
                            placeholderText="dd-mm-yyyy"
                            dateFormat={"dd-MM-yyyy"}
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {" "}
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }

                  if (item.attribute_type === "attachment") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <div
                            className="file-upload"
                            disabled={state.isImageUpload && "disabled"}
                          >
                            <button
                              type="button"
                              className="file-name"
                              htmlFor="custom-attachment"
                              onClick={showModalPopupHandler}
                            >
                              <i
                                className="fa fa-plus hidden-sm"
                                aria-hidden="true"
                              ></i>
                              &nbsp;
                              <span>
                                {state.isImageUpload
                                  ? "Uploading..."
                                  : "Choose Files"}
                              </span>
                            </button>
                            <div className="file-selected"></div>
                          </div>
                          <input
                            type="file"
                            className="form-control"
                            ref={(el) => (focusRef.current[index] = el)}
                            autoComplete={"off"}
                            onChange={onFileChangeHandler}
                            id="custom-attachment"
                            multiple={true}
                            style={{ display: "none" }}
                          />
                        </div>
                        <div className="custom_image">
                          <div className="afterupload-image mt-2 newupload">
                            {Object.keys(state.saveImageFile).length > 0 &&
                              Object.keys(state.saveImageFile).map((item) => {
                                return (
                                  <div className="uploadimages">
                                    <ImagePreview
                                      headImage={state.saveImageFile[item]}
                                      className="newchild_upload"
                                      width="165px"
                                      // gap="5px"
                                      height="80px"
                                    />
                                    <div
                                      className="delete"
                                      onClick={() => removeUploadImage(item)}
                                    >
                                      <svg
                                        width="11"
                                        height="10"
                                        viewBox="0 0 11 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{
                                          marginLeft: "-1px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <path
                                          d="M8.21973 2.5L3.21973 7.5"
                                          stroke="#737373"
                                          stroke-width="1.33"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        ></path>
                                        <path
                                          d="M3.21973 2.5L8.21973 7.5"
                                          stroke="#737373"
                                          stroke-width="1.33"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        ></path>
                                        <title>Remove</title>
                                      </svg>
                                    </div>
                                  </div>
                                );
                              })}
                            {Object.keys(state.editForm?.attachment || {})
                              .length > 0 &&
                              Object.keys(state.editForm.attachment).map(
                                (item) => {
                                  return (
                                    <div className="uploadimages">
                                      <ImagePreview
                                        headImage={
                                          state.editForm.attachment[item]
                                        }
                                        className="newchild_upload"
                                        width="165px"
                                        // gap="5px"
                                        height="90px"
                                      />
                                      <div
                                        className="delete"
                                        onClick={() =>
                                          removeEditUploadImage(item)
                                        }
                                      >
                                        <svg
                                          width="11"
                                          height="10"
                                          viewBox="0 0 11 10"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                          style={{
                                            marginLeft: "-1px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <path
                                            d="M8.21973 2.5L3.21973 7.5"
                                            stroke="#737373"
                                            stroke-width="1.33"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                          <path
                                            d="M3.21973 2.5L8.21973 7.5"
                                            stroke="#737373"
                                            stroke-width="1.33"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                          <title>Remove</title>
                                        </svg>
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                          </div>
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "checkbox") {
                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <input
                            value={formik.values[item.field]}
                            type={"checkbox"}
                            ref={(el) => (focusRef.current[index] = el)}
                            className="form-control"
                            onChange={(evt) =>
                              formik.setFieldValue(item.field, evt.target.value)
                            }
                          />
                        </div>
                        <div
                          type="invalid"
                          style={
                            formik.errors[item.field] &&
                            formik.touched[item.field]
                              ? {
                                  display: "block",
                                }
                              : {}
                          }
                        >
                          {formik.errors[item.field] &&
                          formik.touched[item.field] ? (
                            <div className="error">
                              {formik.errors[item.field]}
                            </div>
                          ) : null}
                        </div>
                      </Row>
                    );
                  }
                  if (item.attribute_type === "category") {
                    const options = item.options;
                    const newoptions = options
                      ?.map((item) => ({
                        label: item.name,
                        value: item._id,
                      }));
      

                    const values = newoptions.filter((opt) =>
                      (!formik.values[item.field] && state.boardConfig.category_board)
                        ? opt.value == state.boardConfig.category_board
                        : opt.value == formik.values[item.field]
                    );

                    if (!formik.values[item.field] && state.boardConfig.category_board) {
                      setTimeout(() => {
                        formik.setFieldValue(item.field, state.boardConfig.category_board);
                      }, 300);
                    }


                    return (
                      <Row className="mb-2" key={index}>
                        <div className="form-group">
                          <label
                            className={
                              "col-12 " +
                              (item.is_required ? "form-label _required" : "")
                            }
                          >
                            {item.headerName}
                          </label>
                          <ReactSelect
                            // isMulti={item.is_multiple}
                            options={newoptions || []}
                            maxMenuHeight={175}
         
                            value={values}
                            name="label"
                            placeholder={commonData.firstUpper(
                              item.headerName
                            )}
                            onChange={(value) =>
                              formik.setFieldValue(
                                item.field,
                                value.value
                              )
                            }
                          />
                        </div>

                      </Row>
                    );
                  }
                })}
              <div className="form-group mt-3">
              <DropDownButon isAdding={state.isAdding} title={state.name}  submitandopenmodalform={()=>submitandopenmodalform(formik)}/>
              </div>
            </Form>
          );
        }}
      </Formik>
    );
  };

  const callRowApi = useCallback(
    async (key, relationType = '') => {
      let dataColumns = child_board.filter((item) => {
        return item.attribute_set_key == key && item;
      });
      filterIcon.current = "";
      setState((prev) => {
        return {
          ...prev,
          columns: dataColumns?.[0]?.data?.list || [],
          selectedrowsdata: [],
          globalSearch: "",
          filterMod: "",
          isReset: !prev.isReset,
          key: key,
          selectColumnsCheck: [],
          keyname: dataColumns[0]?.attribute_set_name,
          deselectAll: true,
          relation_type: relationType,
        };
      });

      onGridReady(state.gridApi, key);
    },
    [state.key, state.isFullScreenView, state.gridApi, state.selectedrowsdata]
  );
  const childFunc = async (data, uuid) => {
    setState((state) => {
      return {
        ...state,
        showErDetails: true,
        childBoardId: data?.data?.customer_tattle_uuid || uuid,
        rowDataId: data?.data.sequence,
      };
    });
    setState((state) => {
      return {
        ...state,
        attributes: data.column?.columnApi?.columnModel?.columnDefs,
      };
    });
    setState((state) => {
      return {
        ...state,
        rows: data.data,
      };
    });
  };

  const onRowSelected = (event) => {
    const { data, api } = event;
    const newrostate = [...state.selectedrowsdata];
    const indind = newrostate.findIndex(
      (it) => it.customer_tattle_uuid === data.customer_tattle_uuid
    );
    if (
      newrostate[indind]?.customer_tattle_uuid === data.customer_tattle_uuid
    ) {
      newrostate.splice(indind, 1);
    } else {
      newrostate.push(data);
    }

    setState((state) => {
      return {
        ...state,
        selectedrowsdata: gridrefval.current.api.getSelectedRows(),
      };
    });
  };
  const removeChildInfoImage = (uuid, field) => {
    setState((state) => {
      return {
        ...state,
        showModal: true,
        removeerinfoUuid: uuid,
      };
    });
  };

  useEffect(() => {

    const timer = setTimeout(() => {
    focusRef.current?.[0]?.focus();
    }, 10);
    return () => clearTimeout(timer);
  }, [focusRef, showCanvas, state.showEditForm]);
  useEffect(() => {
    (async () => {
      if (state.removeerinfoUuid && state.deleteChildRecord) {
        const attachment = {
          ...delete state.rows["attachment"][state.removeerinfoUuid],
          ...state.rows["attachment"],
        };
        const rows = { ...state.rows };
        const response = await fetch(`${info.apiUrl}attachment/delete`, {
          method: "POST",
          body: JSON.stringify({
            app_token: info.app_token,
            user_uuid: info.user_uuid,
            attribute_key: "attachment",
            attribute_set_key: state.key,
            customer_tattle_uuid: +state.childBoardId,
            file_uuid: state.removeerinfoUuid,
          }),
        });

        const rdata = await response.json();
        if (rdata.code === 200) {
          rows.attachment = attachment;

          setState((state) => {
            return {
              ...state,
              showModal: false,
              rows,
              removeerinfoUuid: "",
              deleteChildRecord: false,
              // createBoard: {
              //   ...state.createBoard,
              //   board: true,
              //   message: rdata.message,
              //   title: "success",
              // },
            };
          });
          // callRowApi(state.key);
        } else {
          setState((state) => {
            return {
              ...state,
              createBoard: {
                ...state.createBoard,
                board: true,
                message: rdata.message,
                title: "failure",
                bg: "danger",
              },
            };
          });
        }
      }
    })();
  }, [state.deleteChildRecord]);
  const getChildErInfo = () => {
    let newRows = attributes.map((item) => {
      if (
        item.field !== "customer_tattle_uuid" &&
        item.field !== "action" &&
        item.field !== "checkiq"
      ) {
        // if (item.attribute_type === "board") {
        //   let { options } = item;
        //   let newval = options.find((itt) => {
        //     console.log(itt, "check itt 47");
        //     return itt.customer_tattle_uuid == state?.rows?.[item.field];
        //   });
        //   return (
        //     <Row>
        //       <Col xs={12} sm={12} md={12} lg={12}>
        //         <div className="story-box">
        //           <div class="row mt-2 ">
        //             <div class="col-4 left-text">
        //               <label>{item.headerName}</label>{" "}
        //             </div>
        //             <div class="col-8 right-text mt-1">
        //               <a
        //                 href={`//${process.env.REACT_APP_LOCAL_URL}tattle/${newval["_id"]?.attribute_set_key}/${newval.customer_tattle_uuid}`}
        //               >
        //                 {newval.customer_tattle_uuid}
        //               </a>
        //             </div>
        //           </div>
        //         </div>
        //       </Col>
        //     </Row>
        //   );
        // }
        if (item.attribute_type === "assign_to") {
          const { options } = item;
          return (
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className="story-box">
                  <div className="row mt-2">
                    <div className="col-4 left-text">
                      <label>{item.headerName}</label>
                    </div>
                    <div className="col-8 right-text">
                      <div className="text">
                        {state.allUsers[state?.rows?.[item.field]]?.name ? (
                          <>
                            <span>
                              <img
                                src={
                                  state.allUsers[state?.rows?.[item.field]]
                                    ?.profile_image
                                }
                                className="rounded imag-canvas"
                              />
                            </span>
                            {state.allUsers[state?.rows?.[item.field]]?.name ||
                              "--"}{" "}
                          </>
                        ) : (
                          "--"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          );
        }
        if (item.attribute_type === "category") {
          const val = item.options.find(
            (ite) => ite._id == state.rows?.[item.field]
          )?.name;

          return (
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className="story-box">
                  <div className="row mt-2">
                    <div className="col-4 left-text">
                      <label>{item.headerName}</label>
                    </div>
                    <div className="col-8 right-text mt-1">
                      <div className="text">{val || "--"}</div>{" "}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          );
        }
        if (item.attribute_type === "select") {
          let val;
          if (!Array.isArray(state.rows?.[item.field])) {
            val = item.options.find(
              (itt) => itt._id === state.rows?.[item.field]
            )?.option_name;
          }
          val = item.options.find((itt) =>
            state.rows?.[item.field]?.includes(itt._id)
          )?.option_name;
          return (
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className="story-box">
                  <div className="row mt-2">
                    <div className="col-4 left-text">
                      <label>{item.headerName}</label>
                    </div>
                    <div className="col-8 right-text mt-1">
                      <div className="text">{val || "--"}</div>{" "}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          );
        }
        if (item.attribute_type === "date") {
          return (
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className="story-box">
                  <div className="row">
                    <div className="col-4 left-text">
                      <label>{item.headerName}</label>
                    </div>
                    <div className="col-8 right-text mt-1">
                      <div className="text">
                        {moment(state.rows?.[item.field]).format(
                          process.env.REACT_APP_DATE_FORMAT
                        ) || "--"}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          );
        }
        if (item.attribute_type === "attachment") {
          const images =
            state.rows?.[item.field] &&
            Object.keys(state.rows?.[item.field]).map((im) => (
              <div className="uploadimages">
                <ImagePreview
                  headImage={state.rows[item.field][im]}
                  className="newchild_upload"
                  width="105px"
                  height="44px"
                  fileSize="30px"
                />

                <div
                  className="delete"
                  onClick={() => removeChildInfoImage(im, item.field)}
                >
                  <svg
                    width="11"
                    height="10"
                    viewBox="0 0 11 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      marginLeft: "-1px",
                      cursor: "pointer",
                    }}
                  >
                    <path
                      d="M8.21973 2.5L3.21973 7.5"
                      stroke="#737373"
                      stroke-width="1.33"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M3.21973 2.5L8.21973 7.5"
                      stroke="#737373"
                      stroke-width="1.33"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <title>Remove</title>
                  </svg>
                </div>
              </div>
            ));
          return (
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className="story-box">
                  <div className="row">
                    <div className="col-4">
                      <label>{item.headerName}</label>
                    </div>
                    <div className="col-8">
                      <div className="text storyimageupload">{images}</div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          );
        }
        if (item.attribute_type == "text") {
          return (
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className="story-box">
                  <label>{item.headerName}</label>
                  <div className="text">{state.rows?.[item.field]}</div>
                </div>
              </Col>
            </Row>
          );
        }
        if (item.attribute_type == "textarea") {
          return (
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className="story-box">
                  <label>{item.headerName}</label>
                  <TextAreaCompo text={state.rows?.[item.field]} />
                </div>
              </Col>
            </Row>
          );
        }
        if (item.attribute_type == "effort") {
          let newdata =
            checkEffortHandler(
              state.rows[item.field]?.total_hours,
              item.options,
              state.rows[item.field]
            ) || "";
          return (
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className="story-box">
                  <div className="row">
                    <div className="col-4">
                      <label>{item.headerName}</label>
                    </div>
                    <div className="col-8">{newdata}</div>
                  </div>
                </div>
              </Col>
            </Row>
          );
        }
        if (item.attribute_type == "toggle") {
          return (
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className="story-box">
                  <div className="row">
                    <div className="col-4">
                      <label>{item.headerName}</label>
                    </div>
                    <div className="col-8">{state.rows[item.field]}</div>
                  </div>
                </div>
              </Col>
            </Row>
          );
        }
        if (item.attribute_type === "api") {
          const { options } = item;
          return (
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className="story-box">
                  <div className="row mt-2">
                    <div className="col-4 left-text">
                      <label>{item.headerName}</label>
                    </div>
                    <div className="col-8 right-text mt-1">
                      <div className="text">
                        {options.find((it) => it.id == state.rows?.[item.field])
                          ?.value || "--"}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          );
        }
      }
    });

    return newRows;
  };

  const hideSelectedRow = () => {};
  const showAttributeListDropDown = () => {
    setState((state) => {
      return { ...state, showattrdrop: true };
    });
  };
  const hideattrdrop = () => {
    setState((state) => {
      return { ...state, showattrdrop: false };
    });
  };
  const submitBulkUpdate = (data) => {
    const updatedata = {
      ...data,
      app_token: info.app_token,
      user_uuid: info.user_uuid,
      attribute_set_key: state.key,
    };
    dispatch(bulkUpdate(updatedata)).then((res) => {
      if (res.code === 200) {
        setState((state) => {
          return {
            ...state,
            // createBoard: {
            //   ...state.createBoard,
            //   board: true,
            //   message: res.message,
            //   title: "success",
            // },
          };
        });
      }
    });
    gridrefval.current.api.deselectAll();
    setState((state) => {
      return {
        ...state,
        bulkUpdateDone: !state.bulkUpdateDone,
      };
    });
  };

  useEffect(() => {
    if (bulkupdate.bulk === 200) {
      onGridReady(gridrefval.current, state.key);
    }
  }, [bulkupdate.bulk]);
  useEffect(() => {
    (async () => {
      const response = await fetch(
        `${info.apiUrl}tattle/get-relation-type?customer_tattle_uuid=${para.id}`
      );
      const rdata = await response.json();
      if (rdata.code === 200) {
        setState((state) => {
          return {
            ...state,
            relationType: rdata.data.map((item) => ({
              label: item.relation_name,
              value: item.relation_type,
            })),
          };
        });
      }
    })();
  }, [info]);
  const editHandlerEr = (data) => {
    const {
      data: ndata,
      column: {
        columnApi: {
          columnModel: { columnDefs },
        },
      },
    } = data;
    setState((state) => {
      return {
        ...state,
        showEditForm: true,
        editForm: ndata,
        rowDataId: data.rowIndex + 1,
        childBoardId: ndata.customer_tattle_uuid,
      };
    });
  };

  const clearBulkAction = () => {
    if (gridrefval.current && gridrefval.current.api) {
      gridrefval.current.api.deselectAll();
    }

    setState((state) => {
      return {
        ...state,
        selectedrowsdata: [],
      };
    });
  };

  const getGridData = useCallback(
    (key) => {
      if (key === "relate") {
        return (
          <RelateEr
            render={state.renderchilder}
            relationType={state.relationType || []}
            parent_attribute_set_key
            attribute_set_type
            relateColumnData={state.relateColumnData}
            relateRowData={state.relateRowData}
            callApiRelate={callRelateErApi}
            relationAdded={state.relationAdded}
            users={state.allUsers}
            getCallRelatonFunc={getCallRelatonFunc}
            getHistoryData={getHistoryData}
            externalWindowViewCustomModal={externalWindowViewCustomModal}
            closeCustomModalHandler={closeCustomModalHandler}
            isFullScreenView={state.isFullScreenView}
          />
        );
      }
      if (state.boardConfig.category_board) {
        return (
          <RelateEr
            render={state.renderchilder}
            relationType={state.relationType || []}
            parent_attribute_set_key
            attribute_set_type
            relateColumnData={state.relateColumnData}
            relateRowData={state.relateRowData.filter((item) => {
              return item.category === state.boardConfig.category_board;
            })}
            callApiRelate={callRelateErApi}
            relationAdded={state.relationAdded}
            users={state.allUsers}
            getCallRelatonFunc={getCallRelatonFunc}
            getHistoryData={getHistoryData}
            externalWindowViewCustomModal={externalWindowViewCustomModal}
            closeCustomModalHandler={closeCustomModalHandler}
            isFullScreenView={state.isFullScreenView}
          />
        );
      }
      return (
        state.columns.length > 0 && (
          <div className="ag-theme-alpine">
            <div
              className={` ag-theme-bootstrap  ${para.attribute_set_key} childboard`}
              style={{ height: 350, position: "relative" }}
            >
              {state.selectedrowsdata.length > 0 && (
                <Error>
                  <StatusBar
                    noHide={state.columnsHide}
                    hidecolumn={hideSelectedRow}
                    padding={true}
                    showAttributeListDropDown={showAttributeListDropDown}
                    showattrdrop={state.showattrdrop}
                    hideattrdrop={hideattrdrop}
                    child={!state.boardConfig?.showIds}
                    users={state.allUsers}
                    customer_tattle_uuid={para.id}
                    // code={this.props.attributes.code}
                    clearBulkAction={clearBulkAction}
                    selectedrowsdata={state.selectedrowsdata}
                    submitBulkUpdate={submitBulkUpdate}
                    columnDef={attributes}
                  />
                </Error>
              )}
              <Error>
                <AgGridComponent
                  rowModelType="serverSide"
                  key={gridKey}
                  className={state.selectedrowsdata.length > 0 && "absolute"}
                  is_admin={info.is_admin}
                  users={state.allUsers}
                  removeDropIcon={true}
                  columnResize={false}
                  bulkUpdateDone={state.bulkUpdateDone}
                  externalWindowViewCustomModal={externalWindowViewCustomModal}
                  closeCustomModalHandler={closeCustomModalHandler}
                  isFullScreenView={state.isFullScreenView}
                  showIconFullScreen={true}
                  onCellValueChanged={onRowValueChanged}
                  callStatusPanel={perPageSizeChange}
                  rowSelection={state.rowSelection}
                  globalSearch={state.globalSearch}
                  columnDefs={state.columns}
                  attribute_set_type={para.id}
                  editHandlerEr={editHandlerEr}
                  getFilterParams={getFilterParams}
                  deselectAll={state.deselectAll}
                  resetFilter={state.resetFilter}
                  perPageSizeChange={state.perPage.pagination_default_value}
                  cacheBlockSize={state.perPage.pagination_default_value}
                  maxBlocksInCache={state.perPage.pagination_default_value}
                  gridApi={gridrefval.current}
                  isReset={state.isReset}
                  childFunc={childFunc}
                  deleteChild={deleteChild}
                  statusBar={state.statusBar}
                  groupByKeyCreater={""}
                  child={true}
                  enableRangeSelection={true}
                  suppressClickEdit={true}
                  removeCheckBox={true}
                  onRowSelected={onRowSelected}
                  selectAllRowHandler={selectAllRowHandler}
                  onSortRequested={onSortRequested}
                  onCheckBoxChange={""}
                  renameAttribute={""}
                  onColumnResized={(params) => onColumnResized(params, key)}
                  onGridReady={(evt) => {
                    gridrefval.current = evt;
                    onGridReady(evt, state.key);
                  }}
                  showIds={state.boardConfig?.showIds}
                />
              </Error>
            </div>
          </div>
        )
      );
    },
    [
      state.rowData,
      state.columns,
      state.showattrdrop,
      state.selectedrowsdata,
      state.renderchilder,
      state.relationType,
      state.isFullScreenView,
      state.allUsers,
      state.relateColumnData,
      state.relateRowData,
      state.globalSearch,
      state.boardConfig?.showIds,
      state.resetFilter
    ]
  );
  const optionHandler = async (api, evt, val = null, type) => {
    if (evt) {
    } else {
      const resp = await fetch(api);
      const rdata = await resp.json();
      const { code, data } = rdata;
      if (code === 200) {
        let newopt = data.map((nitem) => ({
          label: nitem.customer_tattle_uuid,
          value: nitem.customer_tattle_uuid,
        }));
        let valboard = newopt.filter((ni) => ni.value == val);
        setState((prev) => {
          return {
            ...prev,
            boardOptions: newopt,
          };
        });

        return newopt;
      }
    }
  };
  //close modal function

  const closeModal = () => {
    setState((state) => {
      return {
        ...state,
        showModal: false,
        deleteChildRecord: false,
        showModalEditRemove: false,
      };
    });
  };
  const customStyles = {
    menu: (provided, state) => {
      const height = state.options.length > 5 ? "180px" : "";
      return {
        ...provided,
        height: height,
        overflow: "hidden",
      };
    },
  };
  const getRelatedErApi = async (evt) => {
    if (evt && state.relatedErApiData.length > 0) {
      const newfilter = state.relatedErApiData.filter((ite) =>
        ite.label.toLowerCase().includes(evt.toLowerCase())
      );

      return newfilter;
    }
    const response = await fetch(
      `${info.apiUrl}tattle/rows/?app_token=${info.app_token}&attribute_set_key=${para.attribute_set_key}`
    );
    const rdata = await response.json();
    if (rdata.code === 200) {
      const result = rdata.data.map((ite) => ({
        label: ite.title,
        value: ite.customer_tattle_uuid,
      }));
      setState((state) => {
        return {
          ...state,
          relatedErApiData: result,
        };
      });

      return result;
    }
  };
  const clearTattleIdHandler = () => {
    setState((state) => {
      return {
        ...state,
        related_tattle_id: "",
      };
    });
  };
  const addRelationHandler = async (uuid='') => {
    // changeTheActiveTab();

    const final_relation_type = state.boardConfig?.default_relation || state.relation_type || 1;
    const final_related_tattle_id = uuid || state.related_tattle_id;

    console.log(final_relation_type, final_related_tattle_id, "check final");

    if (!final_relation_type && !final_related_tattle_id) {
      setState((state) => ({
          ...state,
          errorRelation: {
            relationId: "Please Select ID or Title",
            relationType: "Please select the relation type",
          },
      }));
      return;
    } else if (!final_relation_type) {
      setState((state) => ({
          ...state,
          errorRelation: {
            relationType: "Please select the relation type",
          },
      }));
      return;
    } else if (!final_related_tattle_id) {
      setState((state) => ({
          ...state,
          errorRelation: {
            relationId: "Please Select ID or Title",
          },
      }));
      return;
    }
    setState((state) => {
      return {
        ...state,
        isAdding: true,
      };
    });
    let response;
    if(state.boardConfig?.isExternal && state.boardConfig?.attribute_set_key){
          response = await fetch(`${info.apiUrl}/project/update`, {
      method: "POST",
      body: JSON.stringify({
        app_token: info.app_token,
        attribute_set_key: para.attribute_set_key,
        customer_tattle_uuid: +para.id,
        project: {
          [state.boardConfig.attribute_set_key]: [final_related_tattle_id]
        },
        user_uuid: info.user_uuid,
        operation: "add_only"

      }),
    });
    }
    else{
           response = await fetch(`${info.apiUrl}tattle/add-relation`, {
      method: "POST",
      body: JSON.stringify({
        app_token: info.app_token,
        // attribute_set_key: "support-board",
        // customer_tattle_uuid: 68,
        attribute_set_key: para.attribute_set_key,
        customer_tattle_uuid: +para.id,
        related_tattle_id: final_related_tattle_id,
        relation_type: final_relation_type,
        user_uuid: info.user_uuid,
        parent_attribute_set_key,

      }),
    });
    }


    const rdata = await response.json();
    if (rdata.code === 200) {
      if(state.boardConfig.isExternal){
        callRowApi(state.key);
      }else{
        getCallRelatonFunc();
      }
      setState((state) => {
        return {
          ...state,
          related_tattle_id: "",
          renderchilder: !state.renderchilder,
          relationAdded: true,
          clearautocomplete: !state.clearautocomplete,
          isAdding: false,
        };
      });
      return;
    }
    setState((state) => {
      return {
        ...state,
        isAdding: false,
        createBoard: {
          ...state.createBoard,
          board: true,
          message: rdata.message,
          bg: "danger",
          title: "failure",
        },
      };
    });
  };

  const closeCustomModalHandler = () => {
    setGridKey((prevKey) => prevKey + 1);
    setState((state) => {
      return {
        ...state,
        isFullScreenView: false,
      };
    });
  };

  const getFullModalView = () => {
    return (
      state.isFullScreenView && (
        <div className="full-screen-modal-custom">
          <div className="full-screen-modal-custom-body">
            <div className="close_button_fullscreen">
              <IoMdClose
                size={25}
                color="#fff"
                onClick={closeCustomModalHandler}
              />
            </div>
            <div className="modal-custom-body">
              {getGridData(state.key || "relate")}
            </div>
          </div>
        </div>
      )
    );
  };

  return (
    <>
      <Modal
        show={state.attachShow}
        className="tattle-Uppopup addImage"
        close={hideUiModal}
      >
        {getModalContent()}
      </Modal>
      <Modal
        show={state.showModalEditRemove}
        className="confirm"
        close={closeModal}
      >
        <div className="deleteAlert">
          <p>Are you sure you want to remove?</p>
          <div className="actionDelete">
            <Button
              className="muBtn _blue"
              text="Yes"
              onClick={() => removeImageFromErEdit()}
            />{" "}
            &nbsp;
            <Button
              className="muBtn _grey"
              text="Cancel"
              onClick={closeModal}
            />{" "}
          </div>
        </div>
      </Modal>

      <Modal show={state.showModal} className="confirm" close={closeModal}>
        <div className="deleteAlert">
          <p>Are you sure you want to remove?</p>
          <div className="actionDelete">
            <Button
              className="muBtn _blue"
              text="Yes"
              onClick={() => removeChildErStory()}
            />{" "}
            &nbsp;
            <Button
              className="muBtn _grey"
              text="Cancel"
              onClick={closeModal}
            />{" "}
          </div>
        </div>
      </Modal>
      {state.createBoard.board && <Message board={state.createBoard} />}
        <ErCanvas
          show={state.showEditForm}
          onClose={handleCloseEr}
          rowDataId={state.rowDataId}
          name={state.childBoardId}
          board={state.keyname || state.key}
        >
          {state.showEditForm && getPopulateFormData()}
        </ErCanvas>
        <Error>
          <ErCanvas
            show={state.showErDetails}
            onClose={handleCloseEr}
            rowDataId={state.rowDataId}
            childBoardId = {state.childBoardId}
            name={state.childBoardId ? state.childBoardId : ""}
            board={state.keyname || state.key}
            links={`/tattle/${state.key}/${state.childBoardId}`}
          >
            {state.showErDetails && (
            <div className="viewIdCls active">
              <div className="under-viewIdCls child-er-info-details">
                {getChildErInfo()}
              </div>
              <Link
                className="btn muBtn _blue no-boxshadow float-end"
                to={{
                  pathname: `/tattle/${state.key}/${state.childBoardId}`,
                }}
                target="_blank"
              >
                More Details
              </Link>
            </div> ) }
          </ErCanvas>
        </Error>

        <Error>
          <ErCanvas show={showCanvas} onClose={handleCloseEr} name={state.name}>
            {showCanvas && getPopulateFormData()}
          </ErCanvas>
        </Error>

      <Tabs
        variant="tabs"
        defaultActiveKey={
          state.child_board?.[0]
            ? JSON.stringify({
                attributeSetKey: state.child_board[0].attribute_set_key,
                boardConfig: firstBoardConfig, // or build it the same way you do for eventKey
              })
            : undefined
        }
        onSelect={(evt) => {

          const { attributeSetKey, boardConfig } = JSON.parse(evt);

          attrKey.current = attributeSetKey;
          callRowApi(attributeSetKey, boardConfig?.default_relation);
          setState((state) => {
            return {
              ...state,
              boardConfig,
            };
          });
        }}
      >
        {state.child_board.map((item, index) => {

         let boardConfig = {};
          try {
              if (item.board_config) {
                boardConfig = JSON.parse(item.board_config);
              }
            } catch (e) {
              console.error("Invalid board_config JSON:", item.board_config, e);
              boardConfig = {};
            }


          if (item.attribute_set_key === "relate") {
            return (
              <Tab
                title={item.attribute_set_name}
                eventKey={JSON.stringify({
                  attributeSetKey: item.attribute_set_key,
                })}
                className={para.attribute_set_key}
              >
                <div className="relateTabSearch-Box relateer">
                  <div className="row">
                    <div className="col-6">
                      <ReactSelect
                        options={state.relationType}
                        styles={{
                          menuList: (styles) => {
                            return {
                              ...styles,
                              height: "180px",
                              overflowY: "auto",
                            };
                          },
                        }}
                        menuPlacement="auto"
                        isClearable
                        value={state.relationType.filter(
                          (rt) => rt.value === state.relation_type
                        )}
                        onChange={(evt) => {
                          setState((state) => {
                            return {
                              ...state,
                              errorRelation: {
                                ...state.errorRelation,
                                relationType: "",
                              },
                              relation_type: evt?.value,
                            };
                          });
                        }}
                      />
                      <span className="error">
                        {state.errorRelation?.relationType}
                      </span>
                      {/* <select className="form-control selectpicker">
                      
                      <option>one</option>
                      <option>Two</option>
                    </select> */}
                    </div>
                    <div className="col-6">
                      <div className="right-one">
                        <div className="erAutoCompleteFilter">
                          <AutoCompleteRelateER
                            getReletedTattleId={getReletedTattleIdHandler}
                            clearautocomplete={state.clearautocomplete}
                            clearTattleIdHandler={clearTattleIdHandler}
                          />
                          <span className="error idError">
                            {state.errorRelation?.relationId}
                          </span>
                        </div>
                        <button
                          className="inpSearchBtn"
                          type="button"
                          onClick={() => addRelationHandler()}
                          disabled={state.isAdding}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>
            );
          }
          else if (boardConfig.searchNAdd) {

            const filterQuery = boardConfig.filter
            ? Object.entries(boardConfig.filter)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join("&")
            : "";

            return (
              <Tab
                title={`${item.attribute_set_name}`}
                eventKey={JSON.stringify({
                  attributeSetKey: item.attribute_set_key,
                  boardConfig,
                })}
                className={para.attribute_set_key}
              >
                <div className="relateTabSearch-Box relateer">
                  <div className="er_class_add gap-3">

                    {/* <div className="col-9"> */}
                      <div className="right-one">
                        <div className="erAutoCompleteFilter">
                          <AutoCompleteRelateER
                            getReletedTattleId={getReletedTattleIdHandler}
                            clearautocomplete={state.clearautocomplete}
                            clearTattleIdHandler={clearTattleIdHandler}
                            extraQuery={filterQuery}
                            isExternal={boardConfig?.isExternal?? false}
                          />
                          <span className="error idError">
                            {state.errorRelation?.relationId}
                          </span>
                        </div>
                        <button
                          className="inpSearchBtn"
                          type="button"
                          onClick={() => addRelationHandler()}
                          disabled={state.isAdding}
                        >
                          Add
                        </button>

                      </div>
                    {/* </div> */}
                    {/* <div className="col-3"> */}
                    <button
                      className="btn muBtn _blue no-boxshadow addNewBtn"
                      onClick={() => {
                        showCanvasHandler(
                          item.attribute_set_name,
                          boardConfig.attribute_set_key ?? item.attribute_set_key
                        );
                      }}
                      disabled={state.isLoading}
                    >
                      <span className="me-2">+</span>
                      Create {item.attribute_set_name}
                    </button>
                    {
                      main_attribute_set_key && 
                      <div
                        onClick={() => {
                          setState((prev) => ({
                            ...prev,
                            resetFilter: true,
                            isReset: true,
                            filterMod: {},
                            globalSearch: "",
                          }));

                          // Clear grid selection directly
                          if (gridrefval.current?.api) {
                            gridrefval.current.api.deselectAll();
                          }

                          clearSegmentFun();
                          setTimeout(() => {
                            setState((prev) => ({
                              ...prev,
                              resetFilter: false,
                              isReset: false,
                            }));
                          }, 100);
                        }}
                      >
                        <TimeSvg />
                      </div>
                    }
                  </div>
                </div>
                {/* </div> */}
              </Tab>
            );
          }
          return (
            <Tab
              title={item.attribute_set_name}
              eventKey={JSON.stringify({
                  attributeSetKey: item.attribute_set_key,
                  boardConfig,
                })}
              className={item.attribute_set_key}
            >
              <div className="er_class_add">
                <div className="searchBox">
                  <input
                    type="text"
                    className="iputSearch"
                    placeholder={`Search by ${item.attribute_set_name} Title`}
                    value={state.globalSearch}
                    onChange={(evt) => searchGrid(evt)}
                    autoComplete="off"
                  />
                  <span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.5 18C14.6421 18 18 14.6421 18 10.5C18 6.35786 14.6421 3 10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18Z"
                        stroke="#9CA5AF"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M20.9998 21L15.7998 15.8"
                        stroke="#9CA5AF"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </span>
                </div>
                <button
                  className="btn muBtn _blue no-boxshadow addNewBtn"
                  disabled={state.isLoading}
                  onClick={() => {
                    showCanvasHandler(
                      item.attribute_set_name,
                      item.attribute_set_key
                    );
                  }}
                >
                  <span className="me-2">+</span>
                  Add {item.attribute_set_name}
                </button>
              </div>
            </Tab>
          );
        })}
      </Tabs>
      {getFullModalView()}
      <Container className="g-0 p-2">
        <div className="custom-height mb-2">
          {getGridData(state.key || "relate")}
        </div>{" "}
      </Container>
    </>
  );
};

export default React.memo(ChildBoard);
